(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('moneda', {
            parent: 'entity',
            url: '/moneda?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.moneda.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/moneda/monedas.html',
                    controller: 'MonedaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('moneda');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('moneda-detail', {
            parent: 'moneda',
            url: '/moneda/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.moneda.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/moneda/moneda-detail.html',
                    controller: 'MonedaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('moneda');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Moneda', function($stateParams, Moneda) {
                    return Moneda.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'moneda',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('moneda-detail.edit', {
            parent: 'moneda-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/moneda/moneda-dialog.html',
                    controller: 'MonedaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Moneda', function(Moneda) {
                            return Moneda.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('moneda.new', {
            parent: 'moneda',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/moneda/moneda-dialog.html',
                    controller: 'MonedaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descripcion: null,
                                codigo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('moneda', null, { reload: 'moneda' });
                }, function() {
                    $state.go('moneda');
                });
            }]
        })
        .state('moneda.edit', {
            parent: 'moneda',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/moneda/moneda-dialog.html',
                    controller: 'MonedaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Moneda', function(Moneda) {
                            return Moneda.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('moneda', null, { reload: 'moneda' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('moneda.delete', {
            parent: 'moneda',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/moneda/moneda-delete-dialog.html',
                    controller: 'MonedaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Moneda', function(Moneda) {
                            return Moneda.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('moneda', null, { reload: 'moneda' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
